<template>
  <div v-if="pendingProduct || !pendingProduct && !error">
    <main class="l-content">
      <BreadCrumbs :links="crumbsLinks"/>
      <ProductBlockConstructor v-if="isConstructor"
                               :product="product"
                               :pending-product="pendingProduct"
                               ref="constructor"/>
      <ProductBlock v-else
                    :product="product"
                    :pending-product="pendingProduct"
                    ref="product"/>
      <SuperOffer/>
    </main>
  </div>
  <ErrorView v-else/>
</template>

<script>

  import ProductBlock from '../components/ProductBlock'
  import BreadCrumbs from '@/components/BreadCrumbs'
  import ProductBlockConstructor from '@/components/ProductBlockConstructor'
  import {http} from '@/axios'
  import ErrorView from '@/components/ErrorView'
  import {mapActions, mapState} from 'vuex'
  import SuperOffer from '@/components/SuperOffer'
  export default {
    name: 'Product',
    components: {
      SuperOffer,
      ErrorView,
      ProductBlockConstructor,
      BreadCrumbs,
      ProductBlock
    },
    data() {
      return {
        product: {},
        pendingProduct: true,
        crumbsLinks: [],
        error: null
      }
    },
    computed: {
      ...mapState('restaurants', ['active_restaurant']),
      activeRestaurantId() {
        let id = window.localStorage.getItem('active_restaurant_id') || null
        if (this.active_restaurant) {
          id = this.active_restaurant.id
        }
        return id
      },
      productSlug() {
        return this.$route.params.slug
      },
      isConstructor() {
        return this.productSlug === 'classic'
      }
    },
    methods: {
      ...mapActions('restaurants', ['setActiveRestaurant']),
      load() {
        this.pendingProduct = true

        let link = null

        if (this.isConstructor) {
          link = `api/product/classic`
        } else {
          link = `api/product/product?slug=${this.productSlug}`
        }

        http.get(link).then(({data}) => {
          this.product = data.data
          let restaurant_id = this.isConstructor ? 2 : this.product.restaurant_id
          this.crumbsLinks = [
            {
              name: this.$t('Доставка'),
              to: {
                name: 'delivery',
                params: {
                  restaurantId: restaurant_id, //todo: add restaurant_id to constructor
                }
              }
            },
            {
              name: this.product.category.name,
              to: {
                name: 'delivery',
                params: {
                  restaurantId: restaurant_id, //todo: add restaurant_id to constructor
                  categoryId: this.product.category.id
                }
              }
            },
            {
              name: this.product.name
            }
          ]

          if (restaurant_id != this.activeRestaurantId) {
            this.setActiveRestaurant(restaurant_id)
          }
        })
        .catch((error) => {
          this.error = error
        })
        .finally(() => {
          if (this.isConstructor) {
            this.$refs.constructor.setDefault()
          } else {
            this.$refs.product.setDefault()
          }
          this.pendingProduct = false
        })
      },
      resetData() {
        this.product = {}
        this.pendingProduct = true
        this.crumbsLinks = []
        this.error = null
        window.scrollTo({
          top: 0
        })
      }
    },
    created() {
      this.load()
    },
    beforeRouteUpdate(to, from, next) {
      this.resetData()
      next()
      this.load()
    }
  }
</script>

<style>

</style>
